import { render } from "./NotificationHeaderList.vue?vue&type=template&id=a2274980"
import script from "./NotificationHeaderList.vue?vue&type=script&lang=js"
export * from "./NotificationHeaderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__